import React, {useState, useEffect} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Content from '../../layout/content/Content';
import 'react-toastify/dist/ReactToastify.css';

const Aviso = ({titulo, estado}) => {
  const [notificationCount, setNotificationCount] = useState(0);
  useEffect(() => {
    notify(); 
  }, []);
  const notify = () => {
    if(estado){
      toast.success(titulo + ' was updated correctly!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        toastId: notificationCount
        });
    }else{
      toast.error(titulo + ' could not be Updated!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        toastId: notificationCount
        });
    }
  };
    
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        key={notificationCount} 
      />
    </div>
  );
};

export default Aviso;
